/** The brand mark: the square logo (web/brand/logo-1024.png), also the favicon and app icon. */
export function LogoMark({ size = 32 }: { size?: number }) {
  return <img className="logo-mark" src="/logo-96.png" width={size} height={size} alt="" />;
}

export function Logo() {
  return (
    <span className="logo">
      <LogoMark />
      <span className="logo-word">LowCostRouter</span>
    </span>
  );
}
